import { IS_DARK_THEME } from './actionTypes';
const init = false;
export default (state = init, action) => {
    switch (action.type) {
        case IS_DARK_THEME:
            return action.payload || false;
        default:
            return state;
    }
};